module.exports = __webpack_public_path__ + "img/logo.e0fe46ed.svg";